<script>
  import { onMount } from "svelte";
  import Header from "../../views/Header.svelte";

  let visible = false;

  onMount(() => {
    setTimeout(() => {
      visible = true;
    }, 50);
  });
</script>

<style lang="scss">
  .headline {
    display: flex;
    flex-direction: column;
    padding: 0 15em 10em;
    opacity: 1;
    background: transparent url('../assets/termsofuse-headline-bg.png') 0% 0% no-repeat padding-box;

    visibility: hidden;
    opacity: 0;

    &.visible {
      transition: opacity 0.1s;
      visibility: visible;
      opacity: 1;
    }
    .headline__article {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      .headline__text {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;

        h3 {
          width: 12em;
          text-align: center;
        }
      }
    }
  }
</style>

<section class="headline" class:visible={visible}>
  <Header />
  <article class="headline__article">
    <section class="headline__text">
      <h3 class="header-title wc">Terms of use</h3>
    </section>
  </article>
</section>
